<ng-template #template>
    <mlp-ng-modal>
        <div header class="sg-heading__h5">{{ title }}</div>

        <div body class="sg-mw_300 mx-auto text-center">
            <p class="mb-3">{{ description }}</p>

            <mlp-ng-button
                (click)="modalService.close()"
                label="Yes"
            ></mlp-ng-button>

            <mlp-ng-button
                (click)="modalService.dismiss()"
                label="No"
            ></mlp-ng-button>
        </div>
    </mlp-ng-modal>
</ng-template>
